import React from 'react';

const MonthlyCalendar = () => (
  <div className="h-full bg-[var(--color-highlight)] rounded-md flex items-center justify-center text-[var(--color-secondary)]">
    Calendar Placeholder
  </div>
);

export default MonthlyCalendar;
